import { ArSlideJson } from "@custom-types/core-api-legacy-types";
import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { BaseEntityAdapter, BaseEntityState } from "@store/store-types";

export const slideNodesAdapter: BaseEntityAdapter<ArSlideJson> =
  createEntityAdapter({
    selectId: (slideNode) => slideNode.sId.toString(),
  });

const initialState: BaseEntityState<ArSlideJson> =
  slideNodesAdapter.getInitialState();

const slideNodesSlice = createSlice({
  name: "slideNodes",
  initialState,
  reducers: {
    setAll: slideNodesAdapter.setAll,
    resetSlideNodesState: () => initialState,
  },
});

export const { setAll, resetSlideNodesState } = slideNodesSlice.actions;

export const slideNodesReducer = slideNodesSlice.reducer;
